export default __webpack_public_path__ + "graphics/pin-map.fe2a2073.svg";